import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface VideoDuelErrorStateProps {
  message?: string;
  onRetry: () => void;
}

export function VideoDuelErrorState({
  message = translateInterfaceText("Não foi possível carregar a comparação"),
  onRetry,
}: VideoDuelErrorStateProps) {
  useLanguage();
  return (
    <div className="bg-[hsl(var(--card))] rounded-2xl border border-[hsl(var(--border))] flex flex-col items-center justify-center py-16 px-6">
      <div className="h-14 w-14 rounded-2xl bg-[#FEF2F2] flex items-center justify-center mb-4">
        <AlertTriangle className="h-6 w-6 text-[#DC2626]" />
      </div>
      <h3 className="text-[15px] font-semibold text-[hsl(var(--foreground))] mb-1">{message}</h3>
      <p className="text-[13px] text-[hsl(var(--muted-foreground))] text-center max-w-sm mb-5 leading-relaxed">
        {translateInterfaceText("Tente novamente em instantes. Se o problema persistir, entre em contato com o suporte.")}</p>
      <Button
        variant="outline"
        size="sm"
        className="h-9 gap-2 text-xs font-medium border-[hsl(var(--border))]"
        onClick={onRetry}
      >
        <RefreshCw className="h-3.5 w-3.5" />
        {translateInterfaceText("Tentar novamente")}</Button>
    </div>
  );
}
